// Vue 3: Vuex 4 uses createStore
import { createStore } from "vuex";

import Questions from "./modules/newChampQuestions";
import Championship from "./modules/championship";
import _Championship from "./modules/championship/ChampionshipVuex";
import ChampTeam from "./modules/championship/ChampTeamVuex";
import Users from "./modules/users";
import Match from "./modules/championship/MatchVuex";
import Round from "./modules/championship/RoundVuex";

const store = createStore({
  modules: {
    Questions,
    Championship,
    _Championship,
    ChampTeam,
    Match,
    Round,
    Users
  }
});

export default store;
